// Radix menus and popovers render through a portal, so a mousedown on their content lands
// outside the element that owns the trigger. Click-outside handlers use this to keep the
// owner selected while its dropdown is being used.
const POPOVER_SELECTOR = '[data-radix-popper-content-wrapper]'

export const isInsidePopover = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(POPOVER_SELECTOR) !== null
